import { PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { NotifyService } from 'helpers';
import {
  PARENT_PACKAGE_LIST_PARAMS_REQUEST,
  PARENT_PACKAGE_LIST_STATE,
} from 'models/parent-package';
import { call, put, takeLatest } from 'redux-saga/effects';
import { getParentPackageListApi } from 'services/parent-packages';
import { setGlobalLoading } from 'store/reducers/global';
import { setParentPackageListSuccess } from 'store/reducers/parent-packages';
import { GET_PARENT_PACKAGE_OVERVIEW_LIST_REQUEST } from 'store/reducers/parent-packages/actionType';

function* getParentPackageRequest(
  action: PayloadAction<{
    params?: PARENT_PACKAGE_LIST_PARAMS_REQUEST;
  }>
) {
  try {
    yield put(setGlobalLoading(true));
    const response: AxiosResponse<{ data: PARENT_PACKAGE_LIST_STATE }> =
      yield call(getParentPackageListApi, action.payload.params);
    yield put(
      setParentPackageListSuccess({
        records: response.data.data.records,
        metadata: response.data.data.metadata,
      })
    );
    yield put(setGlobalLoading(false));
  } catch (error) {
    NotifyService.error(error);
    yield put(setGlobalLoading(false));
  }
}

function* parentPackages() {
  yield takeLatest(
    GET_PARENT_PACKAGE_OVERVIEW_LIST_REQUEST,
    getParentPackageRequest
  );
}

export default parentPackages;
